import type { FC } from 'react';
import { Activity, LogOut, ShieldCheck, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { OrganizationSelector } from '../organization/OrganizationSelector';

export const Navbar: FC = () => {
  const { user, logout } = useAuth();

  return (
    <header className="h-16 border-b border-slate-800 bg-slate-900/60 backdrop-blur-md sticky top-0 z-30 flex items-center justify-between px-6">
      <div className="flex items-center gap-6">
        <Link to="/" className="flex items-center gap-2.5 font-bold text-lg text-white">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-tr from-brand-600 to-indigo-500 flex items-center justify-center shadow-lg shadow-brand-500/20">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <span className="font-extrabold tracking-tight">keerav camp</span>
          <span className="text-[10px] px-2.5 py-0.5 rounded-full bg-brand-950/80 text-brand-300 font-semibold border border-brand-800/80 hidden sm:inline tracking-wide">
            Developed by Axiino
          </span>
        </Link>

        {user && <OrganizationSelector />}
      </div>

      <div className="flex items-center gap-4">
        <Link
          to="/health"
          className="flex items-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-lg bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 hover:bg-emerald-500/20 transition-colors"
        >
          <Activity className="w-3.5 h-3.5" />
          <span>System Status</span>
        </Link>

        <div className="h-4 w-px bg-slate-800 hidden sm:block" />

        <div className="flex items-center gap-2 text-xs text-slate-400 hidden lg:flex">
          <ShieldCheck className="w-4 h-4 text-emerald-400" />
          <span>Sovereign Mail Engine</span>
        </div>

        {user && (
          <div className="flex items-center gap-3 pl-2 border-l border-slate-800">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center text-xs text-brand-400 font-bold uppercase">
                {user.firstName[0]}
                {user.lastName[0]}
              </div>
              <div className="hidden md:flex flex-col text-left">
                <span className="text-xs font-semibold text-white leading-tight">
                  {user.firstName} {user.lastName}
                </span>
                <span className="text-[10px] text-slate-400 font-mono leading-tight">
                  {user.email}
                </span>
              </div>
            </div>

            <button
              onClick={() => logout()}
              title="Sign Out"
              className="p-1.5 text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-colors"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
